import { FC, useMemo } from 'react';
import { ICustomerProfile } from '../../../CustomerProfileEditScreen/types';
import { formatDate } from 'src/utils/helpers';
import Text, { TEXT } from 'src/view/components/Text/Text';

interface IProps {
  customer: ICustomerProfile;
  dateType: 'first' | 'last' | 'registration';
}

const CustomersProfilesListRowDate: FC<IProps> = ({ customer, dateType }: IProps): JSX.Element => {
  const orderDate = useMemo((): string[] => {
    if (dateType === 'registration') {
      return formatDate(customer.created_at, {}).split(',');
    }
    const date: string | undefined = dateType === 'first' ? customer.first_order?.created_at : customer.last_order?.created_at;
    return formatDate(date, {}).split(',');
  }, [customer, dateType]);

  return (
    <div className="customers-profiles-list-row__element flex-wrap">
      {orderDate?.map((string, index) => (
        <Text key={`customer-date-${index}`} type={TEXT.LIST_ROW} text={string && !index ? string + ',' : string} noTranslate />
      ))}
    </div>
  );
};

export default CustomersProfilesListRowDate;
